import React,{useState} from 'react'
import "./Qualification.css"
import data from "../data/data.json"
const Qualification = () => {
    const [toggleState,setToggleState] =useState(1);
    const toggleTab =(index)=>{
        setToggleState(index)
    }
    const experience = data.qualification.experience;
    const education = data.qualification.education;
  return (
    <section className='qualification  section' id='portfolio'>
        <h2 className='section__title'>Qualification</h2>
        <span className='section__subtitle'>My Personal Journey</span>
        <div className="qualification__container container">
            <div className="qualification__tabs">
                <div className={toggleState === 1 ? "qualification__button button--flex qualification__content-active" :"qualification__button button--flex"} onClick={()=>toggleTab(1)}>
                    <i className='uil uil-graduation-cap qualification__active qualification__icon'></i>Education
                </div>

                <div className={toggleState === 2 ? "qualification__button button--flex qualification__content-active" :"qualification__button button--flex"} onClick={()=>toggleTab(2)}>
                    <i className='uil uil-briefcase-alt qualification__icon'></i>Experience
                </div>
            </div>
            <div className="qualification__sections">
                <div className={toggleState === 1 ? "qualification__content qualification__content-active" :"qualification__content"}>
                  
                {
                education.map(({id,name,description,year})=>{
                    if (id % 2 == 1) {
                        return(
                        <div className="qualification__data">
                            <div>
                                <h3 className='qualification__title'>{name}</h3>
                                <span className='qualification__subtitle'>{description}</span>
                                <div className="qualification__calender">
                                    <i className='uil  uil-calendar-alt'>
                                         {year}
                                    </i>
                                </div>
                            </div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className='qualification__line'></span>
                            </div>
                        </div>
                        )
                    }
                    return(
                        <div className="qualification__data">
                        <div></div>
                        <div>
                            <span className="qualification__rounder"></span>
                            <span className='qualification__line'></span>
                        </div>
                        <div>
                            <h3 className='qualification__title'>{name}</h3>
                            <span className='qualification__subtitle'>{description}</span>
                            <div className="qualification__calender">
                                <i className='uil  uil-calendar-alt'>
                                    {year}
                                </i>
                            </div>
                        </div>
                    </div>
                    )
                    })
                } 
                </div>
                <div className={toggleState === 2 ? "qualification__content qualification__content-active" :"qualification__content"}>
                {
                experience.map(({id,name,description,year})=>{
                    if (id % 2 == 1) {
                        return(
                        <div className="qualification__data">
                            <div>
                                <h3 className='qualification__title'>{name}</h3>
                                <span className='qualification__subtitle'>{description}</span>
                                <div className="qualification__calender">
                                    <i className='uil  uil-calendar-alt'>
                                         {year}
                                    </i>
                                </div>
                            </div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className='qualification__line'></span>
                            </div>
                        </div>
                        )
                    }
                    return(
                        <div className="qualification__data">
                        <div></div>
                        <div>
                            <span className="qualification__rounder"></span>
                            <span className='qualification__line'></span>
                        </div>
                        <div>
                            <h3 className='qualification__title'>{name}</h3>
                            <span className='qualification__subtitle'>{description}</span>
                            <div className="qualification__calender">
                                <i className='uil  uil-calendar-alt'>
                                    {year}
                                </i>
                            </div>
                        </div>
                    </div>
                    )
                    })
                } 
                </div>
            </div>
        </div>
    </section>
  )
}

export default Qualification